export enum SupportedLanguages {
  DEFAULT = "default",
}

export const SupportedLanguagesArray: SupportedLanguages[] = [
  SupportedLanguages.DEFAULT,
];

export const SupportedLangCodeArray: string[] = ["en"];

export type LocalizedStrings<X, T extends string = "default"> = {
  [key in T]: X;
};

export type TextApi<T> = {
  strings: T;
  activeLanguage: SupportedLanguages;
};

export function getLangCode(lang: SupportedLanguages | string): string {
  switch (lang) {
    case SupportedLanguages.DEFAULT:
    default:
      return "en";
  }
}
